import {isEqual} from '@yandex-delivery/utils'
import {useController, useFormContext} from '@yandex-delivery/form'
import {useEffect} from 'react'

import type {Props} from './types'

export function useOffersList(props: Pick<Props, 'offers' | 'name'>) {
  const {offers, name} = props

  const {control} = useFormContext()
  const {field, fieldState} = useController({control, name})

  useEffect(() => {
    if (offers.length === 0) {
      return
    }

    const selectedOffer = field.value

    const foundOffer = offers.find(offer => offer.tariff === selectedOffer?.tariff)
    const fallbackOffer = offers.at(0)

    if (foundOffer === undefined && fallbackOffer !== undefined) {
      field.onChange(fallbackOffer)
    } else if (!isEqual(selectedOffer, foundOffer)) {
      field.onChange(foundOffer)
    }
  }, [field, offers])

  return {
    field,
    fieldState,
  } as const
}
